export default "__VITE_ASSET__BBBh0F9K__"